import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-787b80f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "theme-body" }
const _hoisted_2 = { class: "theme-common-container" }
const _hoisted_3 = { class: "color-select-layout__extra" }
const _hoisted_4 = { class: "custom-select" }

import { PropType } from 'vue'
import { NCollapse, NCollapseItem } from 'naive-ui'
import Icon from '@teams/common/components/icon'
import { IColorOption } from '../useCustomePanal'
import ColorPicker from '@/components/colorpicker/index.vue'
import Color from 'color'


export default /*#__PURE__*/_defineComponent({
  __name: 'customColorPicker',
  props: {
  title: {
    type: String,
    required: true
  },
  colorOptions: {
    type: Array as PropType<IColorOption[]>,
    required: true
  }
},
  setup(__props) {


const gethex = (rgba: string) => {
  if (rgba) {
    const color = Color(rgba)
    return color.hex()
  } else {
    return '#000000'
  }
}

const getOpacity = (rgba: string) => {
  if (rgba) {
    const color = Color(rgba)
    return Math.round(color.alpha() * 100)
  } else {
    return 0
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NCollapse), {
        "default-expanded-names": [__props.title],
        "display-directive": "show"
      }, {
        arrow: _withCtx(() => [
          _createVNode(_unref(Icon), { name: "collapseArrow" })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(NCollapseItem), {
            title: __props.title,
            name: __props.title
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "header"),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.colorOptions, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "color-select-layout",
                  key: index
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(ColorPicker, {
                        color: item.color || '#00000000',
                        "onUpdate:color": item.onColorChange
                      }, null, 8, ["color", "onUpdate:color"]),
                      _createElementVNode("span", null, _toDisplayString(gethex(item.color)), 1),
                      _createElementVNode("span", null, _toDisplayString(getOpacity(item.color)) + "%", 1)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _: 3
          }, 8, ["title", "name"])
        ]),
        _: 3
      }, 8, ["default-expanded-names"])
    ])
  ]))
}
}

})